import React from 'react';
import styled from 'styled-components';
import { UserInfoForm } from '../components/Auth/UserInfoForm';
import glassTheme from '../styles/glassTheme';

const PageContainer = styled.div`
  min-height: 100vh;
  ${glassTheme.gridBackground}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

export const UserInfoPage: React.FC = () => {
  return (
    <PageContainer>
      <UserInfoForm />
    </PageContainer>
  );
};
